import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { DomAvatarDisplay } from '../../avatars/domAvatarDisplay';
import { InfoOutlinedIcon } from '../../icons/infoOutlinedIcon';
import { thunkGoToGameGuidePage } from '../../redux/actions/gameGuideActions';
import { useAppDispatch } from '../../redux/store';
import { DEFAULT_BACKGROUND_COLOR } from '../../styles/colors';
import { isLocalhostEnvironment } from '../../utils/utils';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;
export const PlayerAvatarMessageBoxContents = ({ username, playerAvatar, onClose }) => {
    const dispatch = useAppDispatch();
    // TODO: Add a test for this.
    const onClickUniqueAvatarsInfo = useCallback(() => {
        onClose();
        dispatch(thunkGoToGameGuidePage('unique-avatars'));
    }, [dispatch, onClose]);
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(DialogContentText, { children: playerAvatar.type === 'unique' && (_jsx(Button, { variant: 'outlined', size: 'small', startIcon: _jsx(InfoOutlinedIcon, {}), onClick: onClickUniqueAvatarsInfo, children: "Unique Avatars Info" })) }), _jsx(DomAvatarDisplay, { username: username, playerAvatar: playerAvatar, backgroundColor: DEFAULT_BACKGROUND_COLOR, size: 'large', trimTransparentPixels: !isLocalhostEnvironment() })] }));
};
